const tailwind = require('../tailwind')

module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "/portfolio"

  siteTitle: 'Rizda Dwi Prasetya - Software Engineer', // Navigation and Site Title
  siteTitleAlt: 'Rizda', // Alternative Site title for SEO
  siteTitleShort: 'Rizda', // short_name for manifest
  siteHeadline: 'Rizda Dwi Prasetya Web Developer / Software Engineer', // Headline for schema.org JSONLD
  siteUrl: 'https://rizda.win', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: '/logo.png', // Used for SEO and manifest
  siteDescription: 'Rizda Dwi Prasetya Web Developer / Software Engineer',
  author: 'rizdaprasetya', // Author for schema.org JSONLD

  // siteFBAppID: '123456789', // Facebook App ID - Optional
  // userTwitter: '@uname', // Twitter Username
  ogSiteName: 'Rizda', // Facebook Site Name
  ogLanguage: 'en_US', // Facebook Language
  googleAnalyticsID: 'UA-143747281-1',

  // Manifest and Progress color
  themeColor: tailwind.colors.black,
  backgroundColor: tailwind.colors.blue,
}
